export const DETECTION_TYPES = [
  { id: "cd", title: "Crowd Detection", icon: "PeopleIcon", color: "#1ABC9C" },
  { id: "vd", title: "Vehicle Detection", icon: "DirectionsCarIcon", color: "#E74C3C" },
  { id: "pd", title: "Person Detection", icon: "PersonIcon", color: "#3498DB" },
  { id: "id", title: "Intrusion Detection", icon: "SecurityIcon", color: "#FFC107" },
  { id: "vc", title: "Traffic Congestion", icon: "SecurityIcon", color: "#9B59B6" },
  { id: "ls", title: "Loaded-Unloaded Alerts", icon: "SecurityIcon", color: "#F39C12" },
  { id: "or", title: "Off-Route Alerts", icon: "RouteIcon", color: "#4ECDC4" },
  { id: "oa", title: "Off-Area Alerts", icon: "RouteIcon", color: "#FF1744" },
  { id: "ta", title: "Tamper Alerts", icon: "WarningIcon", color: "#E67E22" },
  { id: "usp", title : "Unauthorized stoppage", icon: "WarningIcon", color: "#E67E22" },
  { id : "os", title : "Over-Speed", icon: "WarningIcon", color: "#E67E22" },
  { id: "ct", title: "Camera Tampering", icon: "WarningIcon", color: "#8E44AD" },
  { id: "sh", title: "Safety Hazard", icon: "WarningIcon", color: "#E67E22" },
  { id: "ii", title : "Insufficient Illumination", icon: "WarningIcon", color: "#E67E22" }
];

export const GEOFENCE_TO_AREA = {
  2: 'Barka Sayal',
  3: 'Hazaribagh',
  4: 'Kuju',
  5: 'Rajrappa',
  6: 'Dhori',
  674: 'Dhori',
  7: 'Bokaro & Kargali',
  8: 'North Karanpura',
  9: 'Rajhara',
  10: 'Argada',
  653: 'Amrapali & Chandragupta',
  260: 'Giridih',
  289: 'Piparwar',
  346: 'Kathara',
  376: 'Bokaro & Kargali',
  386: 'Magadh & Sanghmitra',
  659: 'Argada',
};

export const isOffAreaGeofence = (geofenceId) => {
  return GEOFENCE_TO_AREA.hasOwnProperty(geofenceId);
};

export const getAreaFromGeofenceId = (geofenceId) => {
  return GEOFENCE_TO_AREA[geofenceId] || null;
};

export const DEFAULT_VISIBLE_CARDS = ["cd", "vd", "pd", "id", "sh", "ls"];

export const DASHBOARD_PRESETS = [
  {
    id: "default",
    name: "Default Dashboard",
    description: "Essential monitoring cards",
    cards: ["cd", "vd", "pd", "id", "vc", "ls"],
    icon: "GridViewIcon"
  },
  {
    id: "security",
    name: "Security Focus",
    description: "Security and intrusion monitoring",
    cards: ["cd", "sh", "id", "or", "ta", "ct"],
    icon: "SecurityIcon"
  },
  {
    id: "vehicle",
    name: "Vehicle Operations",
    description: "Vehicle and transport focused",
    cards: ["vd", "vc", "ls", "or", "oa", "ta"], 
    icon: "DirectionsCarIcon"
  },
  {
    id: "alerts",
    name: "Alert Systems",
    description: "Critical alert monitoring",
    cards: ["or", "oa", "ta", "ct", "pd", "id"], 
    icon: "NotificationsIcon"
  },
  {
    id: "detection",
    name: "Detection Focus",
    description: "Core detection systems",
    cards: ["cd", "vd", "pd", "id", "vc", "ls"],
    icon: "VisibilityIcon"
  }
];

export const CARD_PRESETS = DASHBOARD_PRESETS;

export const REPORTS_DETECTION_TYPES = [
  { id: "cd", title: "Crowd Detection", icon: "PeopleIcon" },
  { id: "vd", title: "Vehicle Detection", icon: "DirectionsCarIcon" },
  { id: "pd", title: "Person Detection", icon: "PersonIcon" },
  { id: "id", title: "Intrusion Detection", icon: "SecurityIcon" },
  { id: "vc", title: "Traffic Congestion", icon: "SecurityIcon" },
  { id: "ls", title: "Loading Status", icon: "SecurityIcon" },
  { id: "ct", title: "Camera Tampering", icon: "WarningIcon" },
  { id: "sh", title: "Safety Hazard", icon: "WarningIcon" },
  { id :"ii", title : "Insufficient Illumination", icon: "WarningIcon"},
];

export const EVENT_TYPE_MAP = {
  cd: "Crowd Detection",
  vd: "Vehicle Detection",
  pd: "Person Detection",       
  id: "Intrusion Detection",     
  vc: "Traffic Congestion",
  ls: "Loading State",
  or: "Off-Route Alert",
  oa: "Off-Area Alert", 
  ta: "Tamper Alert",
  os : "Over Speed Alert",
  usp : "Unauthorized Stoppage Alert",
  ct: "Camera Tampering",
  sh: "Safety Hazard",
  ii: "Insufficient Illumination"
};

export const API_TO_APP_DETECTION_MAP = {
  'CD': 'cd',      
  'PD': 'pd',     
  'ID': 'id',      
  'VD': 'vd',       
  'VC': 'vc',       
  'LS': 'ls',      
  'US': 'us',
  'CT': 'ct',     
  'SH': 'sh',
  'II': 'ii',
  'OR': 'or',
  'OA': 'oa' 
};

export const APP_TO_API_DETECTION_MAP = {
  'cd': 'CD',       
  'pd': 'PD',      
  'id': 'ID',       
  'vd': 'VD',       
  'vc': 'VC',      
  'ls': 'LS',      
  'us': 'US',
  'ct': 'CT',      
  'sh': 'SH',
  'ii': 'II',
  'or': 'OR',
  'oa': 'OA' 
};

export const ALL_EVENT_TYPES = ["CD", "PD", "ID", "VD", "VC", "LS", "US", "CT", "SH", "II", "OR", "OA"];

export const DETECTION_TYPE_CONFIG = {
  'cd': {
    apiTypes: ['CD'],
    title: 'Crowd Detection',
    color: '#1ABC9C'
  },
  'pd': {
    apiTypes: ['PD'],  
    title: 'Person Detection',
    color: '#3498DB'
  },
  'id': {
    apiTypes: ['ID'],  
    title: 'Intrusion Detection',
    color: '#FFC107'   
  },
  'vd': {
    apiTypes: ['VD'],
    title: 'Vehicle Detection',
    color: '#E74C3C'
  },
  'vc': {
    apiTypes: ['VC'],
    title: 'Vehicle Counting',
    color: '#9B59B6'
  },
  'ls': {
    apiTypes: ['LS'],
    title: 'Line Crossing',
    color: '#F39C12'
  },
  'us': {
    apiTypes: ['US'],
    title: 'Unauthorized Surveillance',
    color: '#E67E22'
  },
  'or': {
    apiTypes: ['OR'],
    title: 'Off-Route Alert',
    color: '#4ECDC4'
  },
  'oa': { 
    apiTypes: ['OA'],
    title: 'Off-Area Alert',
    color: '#FF1744'
  },
  'ta': {
    apiTypes: ['TA'],
    title: 'Tamper Alert',
    color: '#E67E22'
  },
  'os': {
    apiTypes: ['OS'],
    title: 'Over Speed Alert',
    color: '#E67E22'
  },
  'usp': {
    apiTypes: ['USP'],
    title: 'Unauthorized Stoppage Alert',
    color: '#E67E22'
  },
  'ct': {
    apiTypes: ['CT'],
    title: 'Camera Tampering',
    color: '#8E44AD'
  },
  'sh': {
    apiTypes: ['SH'],
    title: 'Safety Hazard',
    color: '#E67E22'
  },
  'ii': {
    apiTypes: ['II'],
    title: 'Insufficient Illumination',
    color: '#E67E22'
  }
};

export const AREA_ENDPOINTS = {
  'Argada': { endpoint: 'https://argada.cclai.in', groupId: 2 },
  'Barka Sayal': { endpoint: 'https://barkasayal.cclai.in', groupId: 1 },
  'North Karanpura': { endpoint: 'https://nk.cclai.in', groupId: 3 },
  'Bokaro & Kargali': { endpoint: 'https://bk.cclai.in', groupId: 4 },
  'Kathara': { endpoint: 'https://kathara.cclai.in', groupId: 5 },
  'Giridih': { endpoint: 'https://giridih.cclai.in', groupId: 6 },
  'Amrapali & Chandragupta': { endpoint: 'https://amrapali.cclai.in', groupId: 7 },
  'Magadh & Sanghmitra': { endpoint: 'https://magadh.cclai.in', groupId: 8 },
  'Rajhara': { endpoint: 'https://rajhara.cclai.in', groupId: 9 },
  'Kuju': { endpoint: 'https://kuju.cclai.in', groupId: 10 },
  'Hazaribagh': { endpoint: 'https://hazaribagh.cclai.in', groupId: 11},
  'Rajrappa': { endpoint: 'https://rajrappa.cclai.in', groupId: 12 },
  'Dhori': { endpoint: 'https://dhori.cclai.in', groupId: 13 },
  'Piparwar': { endpoint: 'https://piparwar.cclai.in', groupId: 14 }
};

export const SOCKET_URLS = [
  { location: "Barka Sayal", url: "wss://barkasayal.cclai.in/ces", httpsUrl: "https://barkasayal.cclai.in" },
  { location: "Argada", url: "wss://argada.cclai.in/ces", httpsUrl: "https://argada.cclai.in" },
  { location: "North Karanpura", url: "wss://nk.cclai.in/ces", httpsUrl: "https://nk.cclai.in" },
  { location: "Bokaro & Kargali", url: "wss://bk.cclai.in/ces", httpsUrl: "https://bk.cclai.in" },
  { location: "Kathara", url: "wss://kathara.cclai.in/ces", httpsUrl: "https://kathara.cclai.in" },
  { location: "Giridih", url: "wss://giridih.cclai.in/ces", httpsUrl: "https://giridih.cclai.in" },
  { location: "Amrapali & Chandragupta", url: "wss://amrapali.cclai.in/ces", httpsUrl: "https://amrapali.cclai.in" },
  { location: "Magadh", url: "wss://magadh.cclai.in/ces", httpsUrl: "https://magadh.cclai.in" },
  { location: "Rajhara", url: "wss://rajhara.cclai.in/ces", httpsUrl: "https://rajhara.cclai.in" },
  { location: "Kuju", url: "wss://kuju.cclai.in/ces", httpsUrl: "https://kuju.cclai.in" },
  { location: "Hazaribagh", url: "wss://hazaribagh.cclai.in/ces", httpsUrl: "https://hazaribagh.cclai.in" },
  { location: "Rajrappa", url: "wss://rajrappa.cclai.in/ces", httpsUrl: "https://rajrappa.cclai.in" },
  { location: "Dhori", url: "wss://dhori.cclai.in/ces", httpsUrl: "https://dhori.cclai.in" },
  { location: "Piparwar", url: "wss://piparwar.cclai.in/ces", httpsUrl: "https://piparwar.cclai.in" }
];

export const BOOM_BARRIER_SOCKET_URL = "wss://bbstate.cclai.in/ws/boom-barrier";

export const BOOM_AREA_CODE_MAP = {
  'CO01': 'Barka Sayal',
  'CO02': 'Argada',
  'CO03': 'NK',
  'CO04': 'Bokaro and Kargali',
  'CO05': 'Kathara',
  'CO06': 'Magadh & Sanghmitra',
  'CO07': 'Amrapali and Chandragupta',
  'CO08': 'Rajhara',
  'CO09': 'Kuju',
  'CO10': 'Hazaribagh',
  'CO11': 'Rajrappa',
  'CO12': 'Dhori',
  'CO13': 'Piparwar',
  'CO15': 'Giridih'
};

// Maps BOOM_AREA_CODE_MAP display name → area token key (matches AREA_TOKEN_TO_LOCATION / getLoggedInArea())
export const BOOM_DISPLAY_TO_TOKEN = {
  'Barka Sayal':               'barka-sayal',
  'Argada':                    'argada',
  'NK':                        'north-karanpura',
  'Bokaro and Kargali':        'bokaro-kargali',
  'Kathara':                   'kathara',
  'Magadh & Sanghmitra':       'magadh-sanghmitra',
  'Amrapali and Chandragupta': 'amrapali-chandragupta',
  'Rajhara':                   'rajhara',
  'Kuju':                      'kuju',
  'Hazaribagh':                'hazaribagh',
  'Rajrappa':                  'rajrappa',
  'Dhori':                     'dhori',
  'Piparwar':                  'piparwar',
  'Giridih':                   'giridih',
};

// Given a boom-barrier alert's areaCode (e.g. 'CO06'), returns the matching area token (e.g. 'magadh-sanghmitra')
export const getAreaTokenFromBoomAreaCode = (areaCode) => {
  const displayName = BOOM_AREA_CODE_MAP[areaCode];
  return displayName ? BOOM_DISPLAY_TO_TOKEN[displayName] : undefined;
};

export const VEHICLE_ALERT_SOCKET = {
  location: "Vehicle Alerts",
  url: "wss://vtsalerts.cclai.in",
  httpsUrl: "http://vtsalerts.cclai.in:8090"
};

export const VEHICLE_ALERT_TYPE_MAP = {
  "off-route": "Off-Route Alert",
  "off-area": "Off-Area Alert", 
  "tamper": "Tamper Alert",
  "overspeed": "Over Speed Alert",       
  "stoppage": "Unauthorized Stoppage"     
};

export const AREA_TOKEN_TO_LOCATION = {
  'barka-sayal': 'Barka Sayal',
  'argada': 'Argada',
  'north-karanpura': 'North Karanpura',
  'bokaro-kargali': 'Bokaro & Kargali',
  'kathara': 'Kathara',
  'giridih': 'Giridih',
  'amrapali-chandragupta': 'Amrapali & Chandragupta',
  'magadh-sanghmitra': 'Magadh & Sanghmitra',
  'rajhara': 'Rajhara',
  'kuju': 'Kuju',
  'hazaribagh': 'Hazaribagh',
  'rajrappa': 'Rajrappa',
  'dhori': 'Dhori',
  'piparwar': 'Piparwar'
};

export const LOCATION_TO_AREA_TOKEN = {
  'Barka Sayal': 'barka-sayal',
  'Argada': 'argada',
  'North Karanpura': 'north-karanpura',
  'Bokaro & Kargali': 'bokaro-kargali',
  'Kathara': 'kathara',
  'Giridih': 'giridih',
  'Amrapali & Chandragupta': 'amrapali-chandragupta',
  'Magadh & Sanghmitra': 'magadh-sanghmitra',
  'Rajhara': 'rajhara',
  'Kuju': 'kuju',
  'Hazaribagh': 'hazaribagh',
  'Rajrappa': 'rajrappa',
  'Dhori': 'dhori',
  'Piparwar': 'piparwar'
};

export const DRAWER_WIDTH = 250;

export const AREA_OPTIONS = [
  { value: "All", label: "All" },   
  { value: "Barka Sayal", label: "Barka Sayal" },
  { value: "Argada", label: "Argada" },
  { value: "North Karanpura", label: "North Karanpura" },
  { value: "Bokaro & Kargali", label: "Bokaro & Kargali" },
  { value: "Kathara", label: "Kathara" },
  { value: "Giridih", label: "Giridih" },
  { value: "Amrapali & Chandragupta", label: "Amrapali & Chandragupta" },
  { value: "Magadh & Sanghmitra", label: "Magadh & Sanghmitra" },
  { value: "Rajhara", label: "Rajhara" },
  { value: "Kuju", label: "Kuju" },
  { value: "Hazaribagh", label: "Hazaribagh" },
  { value: "Rajrappa", label: "Rajrappa" },
  { value: "Dhori", label: "Dhori" },
  { value: "Piparwar", label: "Piparwar" }
];

export const VEHICLE_ALERT_GROUP_TO_AREA = {
  "1": "barkasayal",
  "2": "argada",
  "3": "northkaranpura",
  "4": "bokarokargali",
  "5": "kathara",
  "6": "giridih",
  "7": "amrapali",
  "8": "magadh",
  "9": "rajhara",
  "10": "kuju",
  "11": "hazaribagh",
  "12": "rajrappa",
  "13": "dhori",
  "14": "piparwar",
  "15": "kathara",  
  "16": "kathara",  
  "17": "kathara",  
  "18": "kathara",  
  "19": "kathara",  
  "20": "bokarokargali", 
  "21": "bokarokargali",  
  "22": "bokarokargali",  
  "23": "dhori",  
  "24": "dhori",  
  "25": "dhori", 
  "26": "barkasayal",  
  "27": "barkasayal",  
  "28": "barkasayal",  
  "29": "barkasayal",  
  "30": "argada",  
  "31": "argada",  
  "32": "argada", 
  "33": "argada", 
  "34": "northkaranpura",  
  "35": "northkaranpura", 
  "36": "northkaranpura",  
  "37": "northkaranpura",  
  "38": "northkaranpura",  
  "39": "kuju",  
  "40": "kuju", 
  "41": "kuju",  
  "42": "rajrappa",  
  "43": "rajrappa",  
  "44": "magadh",  
  "45": "amrapali",  
  "46": "piparwar",  
  "47": "piparwar",  
  "48": "giridih",  
  "49": "giridih",
  "50": "hazaribagh",  
  "51": "hazaribagh",  
  "52": "hazaribagh",  
  "53": "hazaribagh",  
  "54": "hazaribagh", 
  "55": "rajhara",  
  "56": "hazaribagh",  
  "57": "hazaribagh",  
  "58": "kathara" 
};

export const getAreaFromGroupId = (groupId) => {
  const numericGroupId = parseInt(groupId);
  return VEHICLE_ALERT_GROUP_TO_AREA[numericGroupId] || "Unknown Area"};

export const PRIORITY_OPTIONS = [
  { value: "All", label: "All Priorities" },
  { value: "High", label: "High Priority" },
  { value: "Moderate", label: "Moderate Priority" },
  { value: "Low", label: "Low Priority" },
  { value: "Unassigned", label: "Unassigned" }
];

export const CLOSE_STATUS_OPTIONS = [
  { value: "All", label: "All Events" },
  { value: "Open", label: "Open Events" },
  { value: "Closed", label: "Closed Events" }
];

export const PRIORITY_LEVELS = {
  HIGH: "High",
  MODERATE: "Moderate",
  LOW: "Low",
  UNASSIGNED: "Unassigned"
};

export const CLOSE_STATUS_LEVELS = {
  ALL: "All",
  OPEN: "Open",
  CLOSED: "Closed"
};

export const PRIORITY_COLORS = {
  High: "#e74c3c",     
  Moderate: "#f39c12",  
  Low: "#2ecc71",        
  Unassigned: "#95a5a6"  
};

export const CLOSE_STATUS_COLORS = {
  All: "rgba(26, 188, 156, 0.2)",  
  Open: "#3498db",                  
  Closed: "#95a5a6"                 
};

export const getAllEventTypes = () => {
  return ALL_EVENT_TYPES;
};

export const getEventTypesForDetection = (detectionType) => {
  const config = DETECTION_TYPE_CONFIG[detectionType];
  if (config && config.apiTypes) {
    return config.apiTypes;
  }
  console.warn(`No configuration found for detection type: ${detectionType}`);
  return [];
};

export const mapApiEventTypeToApp = (apiEventType) => {
  return API_TO_APP_DETECTION_MAP[apiEventType] || null;
};

export const getEventTypeColor = (detectionType, apiEventType = null) => {
  const config = DETECTION_TYPE_CONFIG[detectionType];
  return config ? config.color : '#95A5A6';
};

export const getEventTypeTitle = (detectionType, apiEventType = null) => {
  const config = DETECTION_TYPE_CONFIG[detectionType];
  return config ? config.title : 'Unknown Event Type';
};

export const isEventClosed = (event) => {
  if (!event || !event.remarks) return false;
  
  try {
    const comment = event.remarks.comment;
    if (!comment) return false;
    
    if (comment.startsWith('REMARKS_HISTORY:')) {
      const historyData = comment.replace('REMARKS_HISTORY:', '');
      const parsed = JSON.parse(historyData);
      
      if (parsed && Array.isArray(parsed.comments)) {
        return parsed.comments.some(remark => 
          remark.comment && remark.comment.startsWith('EVENT_CLOSED_BY_USER:')
        );
      }
    } else {
      return comment.startsWith('EVENT_CLOSED_BY_USER:');
    }
  } catch (error) {
    console.warn('Error checking event close status:', error);
  }
  
  return false;
};

export const getEventCloseStatus = (event) => {
  return isEventClosed(event) ? 'Closed' : 'Open';
};

export const API_TIMEOUT = 30000; 

export {
  API_TO_APP_DETECTION_MAP as default
};